import { NetworkSelection } from 'structure/migration/components/MigrationPanel/NetworkSelection';
import { BridgeAmountInput } from '../BridgeAmountInput/BridgeAmountInput';
import { BridgeDestinationAndAmount } from '../BridgeDestinationAndAmount/BridgeDestinationAndAmount';
import Image from 'next/image';
import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { bridgeAtom } from 'structure/bridge/store/bridgeAtom';
import { BridgeNetworkSelection } from '../BridgeNetworkSelection/BridgeNetworkSelection';
import { getStaticAssetUrl } from 'utils/url';

export function BridgeInputField({
  chainId,
  allowedNetworks,
}: {
  chainId: number;
  allowedNetworks: number[];
}) {
  const [bridgeState] = useAtom(bridgeAtom);

  const outputNetworks = useMemo(() => {
    const supportedTokens = bridgeState.token;
    const chainIds = Object.keys(supportedTokens.address)
      .flat()
      .filter((chain_id) => Number(chain_id) !== chainId)
      .sort();
    const uniqueChains = [...new Set(chainIds)];
    return uniqueChains.map((chainId) => Number(chainId));
  }, [bridgeState.token, chainId]);

  return (
    <div className='relative flex flex-col dark:text-white'>
      <NetworkSelection allowedNetworks={allowedNetworks} />

      <BridgeAmountInput chainId={chainId} />
      <div className='flex justify-center'>
        <Image
          src={getStaticAssetUrl('/sfi/static/svgs/swap-arrow-down.svg')}
          alt='arrow-down'
          className=''
          width={24}
          height={24}
        />
      </div>

      <BridgeNetworkSelection allowedNetworks={outputNetworks} />

      <BridgeDestinationAndAmount />
    </div>
  );
}
